import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('farmFormFields');

    return {
        CLIENT_NAME_FIELD_PLACEHOLDER: t('clientNameFieldPlaceholder'),
        FARM_NAME_FIELD_PLACEHOLDER: t('farmNameFieldPlaceholder')
    };
};

export default useTranslation;
